import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type DimmedLayerState = {
  isDimmedLayerActive: boolean;
};

const initState: DimmedLayerState = {
  isDimmedLayerActive: false,
};

export const useDimmedLayer = createStore({
  name: 'dimmed-layer',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setDimmedLayer: handler('isDimmedLayerActive'),
  };
});
